import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  type PlatformAccessReason,
  platformAccessReasonLabels,
} from '@borradh-workspace/labels';

export function PlatformAccessReasonField({
  value,
  onChange,
  id,
}: {
  value: string;
  onChange: (value: PlatformAccessReason) => void;
  id: string;
}) {
  return (
    <div className="max-w-md space-y-2">
      <Label htmlFor={id}>Reason for access</Label>
      <Select
        value={value}
        onValueChange={(value) => onChange(value as PlatformAccessReason)}
      >
        <SelectTrigger id={id}>
          <SelectValue placeholder="Choose a reason" />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(platformAccessReasonLabels).map(([key, label]) => (
            <SelectItem key={key} value={key}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-sm text-muted-foreground">
        Needed for GDPR compliance.
      </p>
    </div>
  );
}
